module.exports = __webpack_public_path__ + "img/tiket.8fda5b3.png";